import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ExpenseCategory } from '../state-man/models/expense-type.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class ExpenseCategoryService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  public async getAll () : Promise<ExpenseCategory[] | null> {      
    try {
      const ret = await this.apiService.apiReturnsAny('get', 'expenses/expense_categories/')        
      return (ret && Array.isArray(ret)) ? ExpenseCategory.buildMany(ret) : null
    } catch (error) {   
      LoggerService.log(error + 'expense_categories/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')     
      return null
    }
  }  
  
}
